import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import FieldSchemesAppQuery from './__generated__/FieldSchemesAppQuery.graphql';

export const globalAdminFieldSchemesEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-jira-admin-pages-field-schemes" */ './FieldSchemesApp.tsx'
			),
	),
	getPreloadProps: ({ tenantContext }: EntryPointRouteParams) => ({
		queries: {
			pageQueryRef: {
				parameters: FieldSchemesAppQuery,
				variables: {
					cloudId: tenantContext.cloudId,
				},
				options: {
					fetchPolicy: 'network-only' as const,
				},
			},
		},
	}),
});
